/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

import {
  FileSystemCreateOptionalParams,
  FileSystemCreateResponse,
  FileSystemSetPropertiesOptionalParams,
  FileSystemSetPropertiesResponse,
  FileSystemGetPropertiesOptionalParams,
  FileSystemGetPropertiesResponse,
  FileSystemDeleteOptionalParams,
  FileSystemDeleteResponse,
  FileSystemListPathsOptionalParams,
  FileSystemListPathsResponse,
  FileSystemListBlobHierarchySegmentOptionalParams,
  FileSystemListBlobHierarchySegmentResponse,
} from "../models/index.js";

/** Interface representing a FileSystemOperations. */
export interface FileSystemOperations {
  /**
   * Create a FileSystem rooted at the specified location. If the FileSystem already exists, the
   * operation fails.  This operation does not support conditional HTTP requests.
   * @param options The options parameters.
   */
  create(
    options?: FileSystemCreateOptionalParams,
  ): Promise<FileSystemCreateResponse>;
  /**
   * Set properties for the FileSystem.  This operation supports conditional HTTP requests.  For more
   * information, see [Specifying Conditional Headers for Blob Service
   * Operations](https://learn.microsoft.com/rest/api/storageservices/specifying-conditional-headers-for-blob-service-operations).
   * @param options The options parameters.
   */
  setProperties(
    options?: FileSystemSetPropertiesOptionalParams,
  ): Promise<FileSystemSetPropertiesResponse>;
  /**
   * All system and user-defined filesystem properties are specified in the response headers.
   * @param options The options parameters.
   */
  getProperties(
    options?: FileSystemGetPropertiesOptionalParams,
  ): Promise<FileSystemGetPropertiesResponse>;
  /**
   * Marks the FileSystem for deletion.  When a FileSystem is deleted, a FileSystem with the same
   * identifier cannot be created for at least 30 seconds. While the filesystem is being deleted,
   * attempts to create a filesystem with the same identifier will fail with status code 409 (Conflict),
   * with the service returning additional error information indicating that the filesystem is being
   * deleted. All other operations, including operations on any files or directories within the
   * filesystem, will fail with status code 404 (Not Found) while the filesystem is being deleted. This
   * operation supports conditional HTTP requests.  For more information, see [Specifying Conditional
   * Headers for Blob Service
   * Operations](https://learn.microsoft.com/rest/api/storageservices/specifying-conditional-headers-for-blob-service-operations).
   * @param options The options parameters.
   */
  delete(
    options?: FileSystemDeleteOptionalParams,
  ): Promise<FileSystemDeleteResponse>;
  /**
   * List FileSystem paths and their properties.
   * @param recursive Required
   * @param options The options parameters.
   */
  listPaths(
    recursive: boolean,
    options?: FileSystemListPathsOptionalParams,
  ): Promise<FileSystemListPathsResponse>;
  /**
   * The List Blobs operation returns a list of the blobs under the specified container
   * @param options The options parameters.
   */
  listBlobHierarchySegment(
    options?: FileSystemListBlobHierarchySegmentOptionalParams,
  ): Promise<FileSystemListBlobHierarchySegmentResponse>;
}
